import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';

interface EmspBoTariffIdFilterStateControllerProps {
  value: string;
  onRemove: FilteredItemProps['onRemove'];
}

export const EmspBoTariffIdFilterStateController = ({
  value,
  onRemove,
}: EmspBoTariffIdFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return <FilteredItem icon="tool-02" label={value} onRemove={onRemove} />;
};
